export const locationsData = [
  {
    id: 1,
    name: "Loewe Saal",
    features: ["modern", "wedding", "historisch"],
    description:
      "Der Loewesaal ist mit seinem eleganten Design und großem Raum ideal für unvergessliche Hochzeiten.",
    images: [
      "/images/locations/loewesaal/1.webp",
      "/images/locations/loewesaal/2.webp",
      "/images/locations/loewesaal/3.webp",
    ],

    capacity: 200,
    location: "Berlin",
    url: "http://loewesaal.de",
  },
  {
    id: 2,
    name: "Saal Ma Jolie",
    features: ["wedding", "mitte"],
    description:
      "Saal MaJolie ist mit romantischer Atmosphäre und stilvollen Details perfekt für Ihre Traumhochzeit.",
    images: [
      "/images/locations/saal-majolie/1.jpg",
      "/images/locations/saal-majolie/2.jpg",
      "/images/locations/saal-majolie/3.jpg",
    ],
    capacity: 250,
    location: "Berlin",
    url: "https://www.loewesaal.de",
  },
  {
    id: 3,
    name: "Saal Ma Vie",
    features: ["wedding", "mitte"],
    description:
      "Saal Mavie bringt mit modernem Design und professionellem Service Glanz in Ihre Feier.",
    images: [
      "/images/locations/saal-mavie/1.jpg",
      "/images/locations/saal-mavie/2.jpg",
      "/images/locations/saal-mavie/3.jpg",
    ],
    capacity: 150,
    location: "Berlin",
    url: "https://www.loewesaal.de",
  },
  {
    id: 4,
    name: "Berliner Salon",
    features: ["Panoramablick", "modern", "Außenbereich"],
    description:
      "Der Berliner Salon vereint Klassik und Moderne in einem stilvollen Veranstaltungssaal.",
    images: [
      "/images/locations/berliner-salon/1.webp",
      "/images/locations/berliner-salon/2.jpeg",
    ],
    capacity: "50-80",
    location: "Berlin",
    url: "https://www.loewesaal.de",
  },
  {
    id: 5,
    name: "Saal Tek Dream",
    features: ["Speicherstadt", "Außenbereich", "historisch"],
    description:
      "Saal Tek Dream überzeugt mit moderner Technik und großzügigem Raumkonzept für jedes Event.",
    images: [
      "/images/locations/saal-tekdream/1.jpeg",
      "/images/locations/saal-tekdream/2.jpeg",
      "/images/locations/saal-tekdream/3.jpeg",
      "/images/locations/saal-tekdream/4.jpeg",
      "/images/locations/saal-tekdream/5.jpeg",
      "/images/locations/saal-tekdream/6.jpeg",
    ],
    capacity: 300,
    location: "Berlin",
    url: "https://www.tekdream.de",
  },
  {
    id: 6,
    name: "Saal Antea",
    features: ["wedding", "mitte", "modern"],
    description:
      "Saal Antea besticht durch elegante Architektur und einladendes Ambiente für Ihre Feste.",
    images: [
      "/images/locations/saalantea/1.webp",
      "/images/locations/saalantea/2.webp",
      "/images/locations/saalantea/3.webp",
      "/images/locations/saalantea/4.webp",
      "/images/locations/saalantea/5.webp",
      "/images/locations/saalantea/6.webp",
    ],
    capacity: "85-370",
    location: "Berlin",
    url: "https://www.saalantea.de",
  },
  {
    id: 7,
    name: "Avus Tribüne",
    features: ["Außenbereich", "Restaurant"],
    description:
      "Die Avus Tribüne bietet mit historischem Flair und einzigartigem Ausblick ein besonderes Erlebnis.",
    images: [
      "/images/locations/avus-tribune/1.jpeg",
      "/images/locations/avus-tribune/2.jpeg",
      "/images/locations/avus-tribune/3.jpeg",
    ],
    capacity: 100,
    location: "Berlin",
    url: "https://www.loewesaal.de",
  },
  {
    id: 8,
    name: "Seepferdchen",
    features: ["modern", "mitte", "wedding"],
    description:
      "Das Seepferdchen verleiht Ihren Feiern mit kreativem Design und gemütlicher Atmosphäre eine besondere Note.",
    images: [
      "/images/locations/seeferdchen/1.jpeg",
      "/images/locations/seeferdchen/2.jpeg",
      "/images/locations/seeferdchen/3.jpeg",
    ],
    capacity: 80,
    location: "Berlin",
    url: "https://www.loewesaal.de",
  },
  {
    id: 9,
    name: "Antea Catering",
    features: ["catering", "mitte", "wedding"],
    description:
      "Antea Catering sorgt mit köstlichen Menüs und perfektem Service für besondere kulinarische Momente.",
    images: [
      "/images/locations/antea-catering/1.jpg",
      "/images/locations/antea-catering/2.jpg",
      "/images/locations/antea-catering/3.jpg",
    ],
    capacity: 370,
    location: "Berlin",
    url: "https://www.anteacatering.de",
  },
];
